import React, { ReactNode } from 'react';
import './contact-form-heading.scss';

interface ContactFormHeadingProps {
  children: ReactNode;
}

const ContactFormHeading = ({ children }: ContactFormHeadingProps) => (
  <div className="contact-form-heading">{children}</div>
);

export default ContactFormHeading;
